import { render, staticRenderFns } from "./RearrangeManagement.vue?vue&type=template&id=4c2776cb&"
import script from "./RearrangeManagement.vue?vue&type=script&lang=js&"
export * from "./RearrangeManagement.vue?vue&type=script&lang=js&"
import style0 from "./RearrangeManagement.vue?vue&type=style&index=0&id=4c2776cb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports